import type { StyleRule } from '@archipro-design/aria';
import { pxToRem } from '@archipro-design/aria';

export { Grid, Spacer } from '@modules/project/component/summary/Summary.style';

export const EnquiryTitle: StyleRule = () => ({
    textTransform: 'uppercase',
    marginBottom: pxToRem(15),
});
export const ProjectEnquiryFormContainer: StyleRule = ({ theme }) => ({
    [theme.screen.tablet]: {
        marginTop: pxToRem(40),
    },
});

export const CustomEnquriyMessage: StyleRule = () => ({
    whiteSpace: 'pre-wrap',
    marginBottom: pxToRem(15),
});
